// extracted by mini-css-extract-plugin
module.exports = {"my_profile_welcome_card":"ProfileAdvertisingCard_my_profile_welcome_card__3yJN_","card_footer":"ProfileAdvertisingCard_card_footer__1-nel"};